import React, { useState } from 'react';
import { Navbar } from './Navbar';
import { TenantSidebar, LandlordSidebar, AdminSidebar } from './Sidebar';
import { useAuth } from '../context/AuthContext';
import { Menu, X } from 'lucide-react';
import { cn } from '../lib/utils';
import AIChatWidget from './AIChatWidget';

export const DashboardLayout = ({ children }) => {
  const { user } = useAuth();
  const isTenant = user?.role === 'tenant';
  const isAdmin = ['super_admin', 'admin', 'support_agent'].includes(user?.role);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Show AI chat widget for tenants and landlords (not admins)
  const showAIChatWidget = user && !isAdmin;

  const renderSidebar = () => {
    if (isAdmin) {
      return <AdminSidebar onNavigate={() => setSidebarOpen(false)} />;
    } else if (isTenant) {
      return <TenantSidebar onNavigate={() => setSidebarOpen(false)} />;
    } else {
      return <LandlordSidebar onNavigate={() => setSidebarOpen(false)} />;
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      {/* Mobile sidebar toggle button - positioned to not overlap content */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="lg:hidden fixed bottom-20 right-4 z-50 p-3 bg-primary text-white rounded-full shadow-lg hover:bg-primary/90 transition-colors"
        aria-label="Toggle menu"
      >
        {sidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {/* Mobile sidebar overlay */}
      <div
        className={cn(
          "fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity duration-200",
          sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        )}
        onClick={() => setSidebarOpen(false)}
      />

      <div className="flex">
        {/* Sidebar - responsive */}
        <aside className={cn(
          "fixed lg:sticky top-0 left-0 z-40 h-screen lg:h-auto",
          "w-64 bg-white border-r transform transition-transform duration-300 ease-out",
          "lg:transform-none lg:translate-x-0",
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        )}>
          <div className="h-full overflow-y-auto pt-16 lg:pt-0">
            {renderSidebar()}
          </div>
        </aside>

        {/* Main content - responsive padding */}
        <main className="flex-1 min-w-0 p-4 sm:p-6 lg:p-8">
          {children}
        </main>
      </div>
      
      {/* Floating AI Chat Widget for tenants and landlords */}
      {showAIChatWidget && <AIChatWidget />}
    </div>
  );
};

export default DashboardLayout;
